import { SearchField } from '@cinch-labs/design-system'
import styles from './postcode-search.module.css'
import { useState } from 'react'

interface PostcodeSearchProps {
  setPostcode: (postcode: string) => void
  errorText?: string
  buttonText: string
}

export const PostcodeSearch = ({
  setPostcode,
  errorText,
  buttonText,
}: PostcodeSearchProps) => {
  const [postcodeInput, setPostcodeInput] = useState<string>('')

  return (
    <SearchField
      button={{
        children: buttonText,
        type: 'button',
        onClick: () => setPostcode(postcodeInput),
        classNames: { button: styles.searchButton },
      }}
      label={{ children: 'Postcode', htmlFor: 'postcode-input' }}
      input={{
        id: 'postcode-input',
        name: 'postcode-input',
        onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
          setPostcodeInput(e.target.value),
      }}
      error={{ show: !!errorText, message: errorText }}
      className={styles.searchContainer}
    />
  )
}
